/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.CompensationSettings {
    "use strict";
    
    export class CompensationSettingsContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $mdSidenav: ng.material.ISidenavService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.compensationSettings;
            this.baseEndpoint2 = appSettings.API_ENDPOINTS.periodSettings;
            this.sectionTemplatePath = "app/plugins/compensationSettings/sectionViews/";
            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    true,
                    `${this.appSettings.API_ROOT}/${this.baseEndpoint2}`,
                    "?includeMetadata=true",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.PayrollSettingsMain,
                    this.identityService,
                    this.modalService,
                    this.trackingService,
                    this.$mdSidenav,
                    this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_COMMISSIONDETAIL + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new CommissionDetailSection(1,
                    "SECTION_COMMISSION_DETAIL",
                    "commissionDetail.html",
                    false,
                    false,
                    this.baseEndpoint,
                    "?includeMetadata=true",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.PayrollSettingsCommissionDetail,
                    this.identityService,
                    this.modalService,
                    this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_COMMISSIONDETAIL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_SPLITCOMMISSIONSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new SplitCommissionSection(2,
                    "SECTION_BUSINFO_SPLIT_COMMISSIONS",
                    "splitCommission.html",
                    false,
                    false,
                    "",
                    "/splitcommissionsettings",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.PayrollSettingsSplitCommissions,
                    this.identityService,
                    this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_SPLITCOMMISSIONSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_CLOCKINOUTRULES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ClockInOutRulesSection(3,
                    "SECTION_CLOCKINOUTRULES",
                    "clockInOutRules.html",
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.clockInOutRulesSettings,
                    "?includeMetadata=true",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.PayrollSettingsClockInOutRules,
                    this.identityService,
                    this.modalService,
                    this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_CLOCKINOUTRULES + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            this.activate();
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.auditNoun = Meevo.Model.NounEnum.CompensationSettings;
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_COMMISSIONDETAIL);
                    break;
                case 2:
                    this.auditNoun = Meevo.Model.NounEnum.PayrollSettingsSplitCommissionSetting;
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_SPLITCOMMISSIONSETTINGS_TAB_MAIN);
                    break;
                case 3:
                    this.auditNoun = Meevo.Model.NounEnum.ClockInOutRulesSettings;
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_CLOCKINOUTRULES);
                    break;
                default:
                    this.auditNoun = Meevo.Model.NounEnum.PeriodSettings;
                    this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_PAYROLLSETTINGS_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey +
                ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.copySecurityKey = baseKey +
                ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);

        }

        initializeHeader(model: any): void {
            let businessInfo = <Meevo.Model.BusinessInfo>model;
            this.headerContent = businessInfo.storeName;
  
        }

        openSplitCommissionEditor(context: any, _splitCommission: Model.SplitCommissionSetting) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/compensationSettings/sectionViews/splitCommissionModal.html",

                clickOutsideToClose: true,
                locals: {
                    context: context,
                    splitItem: _splitCommission
                },
                controller: "meevo.plugins.SplitCommissionEditorController",
                controllerAs: "vm"
            }

            this.modalService.showCustom(options);
        }

        

    }
}